/** User-facing breakdown for the SOM tag detail dialog (replaces a single red wall of text). */
export interface SomQueryUserFacingError {
  title: string;
  paragraphs: string[];
}

const FAILED_QUERY_PREFIX = /^Failed to query SOM tags:\s*/i;
const AGGREGATOR_ERRORS_PREFIX = /^Aggregator request errors for tag\(s\):\s*/i;

/**
 * Maps long rules/aggregator error strings to a short title and sentence paragraphs.
 */
export function formatSomTagQueryUserFacingError(message: string): SomQueryUserFacingError {
  const raw = message.trim();
  if (!raw) {
    return { title: "Request failed", paragraphs: [] };
  }

  const lower = raw.toLowerCase();
  let title = "We couldn’t load this section";
  if (lower.includes("som section not found") || lower.includes("no data exists for tag")) {
    title = "No SOM content for this tag";
  } else if (/\b401\b/.test(raw) || /\b403\b/.test(raw) || lower.includes("unauthorized")) {
    title = "Access denied";
  } else if (/\b404\b/.test(raw)) {
    title = "Not found";
  }

  let body = raw
    .replace(FAILED_QUERY_PREFIX, "")
    .replace(AGGREGATOR_ERRORS_PREFIX, "")
    .trim();
  if (!body) {
    body = raw;
  }

  /** Split on period+space before a capital letter, but not after "e.g." / "i.e." abbreviations. */
  const chunks = body.split(
    /(?<!\b[eE]\.[gG])(?<!\b[iI]\.[eE])\. (?=[A-Z])/,
  );
  const paragraphs = chunks
    .map((p) => {
      const t = p.trim();
      if (!t) return "";
      return /[.!?…]$/.test(t) ? t : `${t}.`;
    })
    .filter(Boolean);

  return {
    title,
    paragraphs: paragraphs.length > 0 ? paragraphs : [body],
  };
}
